import styled from 'styled-components';
import { FC } from 'react';
import { TypeBody } from '../Typography';
import Button from '../Button';
import {
  Frame,
  BookendTitle,
  BookendWordWrapper,
  BookendWord,
  BookendContent,
  Eyebrow,
} from './bookend.styled';
import type { BookendProps } from './index';
import NextImage from 'next/image';
import { useInView } from 'react-intersection-observer';
import { buttonEventHandler } from 'lib/utils/button-event-handler';

const StyledFrame = styled(Frame)<{ align: 'start' | 'center' | 'end' }>``;

export const BookendItem: FC<{ item: BookendProps; index: number }> = ({
  item,
  index: _index,
}) => {
  const align = item.align ?? 'center';
  // This waits to load the big background photo until it's about a screen away, so it doesn't fight the hero for bandwidth
  const { ref: frameRef, inView: showBackground } = useInView({
    triggerOnce: true,
    rootMargin: '100% 0px',
  });

  const handleClick = (item: BookendProps) => {
    buttonEventHandler(`${item.primaryButton.label}`, 'Bookend');
  };

  return (
    <StyledFrame
      ref={frameRef}
      align={align}
      style={
        showBackground
          ? { backgroundImage: `url(${item.media.src})` }
          : undefined
      }
    >
      {['center', 'end'].includes(align) && item.eyebrow && (
        <Eyebrow align={align} className='eyebrow'>
          {item.eyebrow}
        </Eyebrow>
      )}

      <BookendContent>
        {item.additionalImage && (
          <div
            style={{
              marginTop: 0,
              width: `${item.additionalImage.width}px`,
              height: `${item.additionalImage.height}px`,
              alignSelf: 'center',
            }}
          >
            <NextImage
              src={item.additionalImage.src}
              alt={item.additionalImage.alt}
              width={item.additionalImage.width}
              height={item.additionalImage.height}
            />
          </div>
        )}
        <div>
          <BookendTitle data-pill={item.pill}>
            {item.titleStyle ? (
              <span style={item.titleStyle}>{item.title}</span>
            ) : (
              item.title
            )}
            {item.word && (
              <BookendWordWrapper
                as='span'
                className='is-visible'
                color='inverse-primary'
              >
                <BookendWord as='span' color='inverse-primary'>
                  {item.word}
                </BookendWord>
              </BookendWordWrapper>
            )}
          </BookendTitle>
        </div>
        <div>
          <TypeBody color='inverse-primary'>{item.body}</TypeBody>
        </div>

        <div>
          <Button
            onClick={() => handleClick(item)}
            url={item.primaryButton.url}
            color={item.primaryButton.color ?? 'snowwhite'}
            label={item.primaryButton.label}
          />
        </div>
      </BookendContent>
    </StyledFrame>
  );
};
